import {Component, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Store} from '@ngxs/store';
import {Auth} from '../../actions/auth.actions';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthState} from '../../state/auth.state';
import Login = Auth.Login;

@Component({
  standalone: false,
  selector: 'app-login',
  templateUrl: './login.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  public username = '';
  public password = '';
  public organization = '';

  public hidePassword = true;
  public loginLoading = false;

  constructor(private store: Store, private router: Router, private route: ActivatedRoute) {
  }

  ngOnInit(): void {
    this.organization = this.store.selectSnapshot(AuthState.organization);
    this.store.selectOnce(AuthState.isAuthenticated).subscribe(async (isAuthenticated) => {
      if (isAuthenticated) {
        await this.navigate();
      }
    });
  }

  login(): void {
    this.loginLoading = true;
    this.store.dispatch(new Login({
      username: this.username,
      password: this.password,
      organizationHandle: this.organization
    })).subscribe(async () => {
      await this.navigate();
      this.loginLoading = false;
    }, (error: Error) => {
      this.loginLoading = false;
    });
  }

  async navigate(): Promise<void> {
    const redirect = this.route.snapshot.queryParamMap.get('redirect');
    if (redirect) {
      await this.router.navigateByUrl(redirect);
    } else {
      await this.router.navigateByUrl('/home');
    }
  }
}
